import styled from 'styled-components';
import { func, node, oneOf } from 'prop-types';
import Icon from '../Icon';

const kindStyles = ({ theme, kind }) =>
  ({
    primary: `
      background-color: ${theme.colors.information_bg};
    `,
    negative: `
      background-color: ${theme.colors.negative_bg};
    `,
  }[kind]);

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  position: relative;
  padding: 0.5em 1em;

  ${(props) => kindStyles(props)};
`;

const IconWrapper = styled.div`
  margin-left: 1em;
  cursor: pointer;

  ${Icon} {
    font-size: 0.75em;
  }
`;

const Content = styled.div`
  flex-grow: 1;
`;

function Notification({children, kind, onClose}) {
  return (
    <Wrapper kind={kind}>
      <Content>{children}</Content>
      <IconWrapper role="button" onClick={onClose}>
        <Icon>close</Icon>
      </IconWrapper>
    </Wrapper>
  );
}

Notification.propTypes = {
  children: node.isRequired,
  kind: oneOf(['primary', 'negative']),
  onClose: func.isRequired,
}

Notification.defaultProps = {
  kind: 'primary'
}

export default Notification;